<template>
  <van-popup v-model="visible" position="bottom" :style="{ height: '100%' }" @close="hidePopup">
    <van-nav-bar
      :title="title"
      left-arrow
      :right-text="form.id?'删除':''"
      @click-right="deleteUserFn"
      @click-left="hidePopup"
    />
    <!-- @click-right="sureFn" -->
    <van-form ref="harvestForm" label-width="60px" class="harvest-form" @submit="submitForm">
      <div class="main">
        <van-cell-group class="item-warp">
          <van-field
            v-model="form.name"
            label="姓名"
            placeholder="请输入姓名"
            :rules="[{required:true,message: '请输入员工姓名'}]"
          />
          <van-field
            v-model="form.mobile"
            :clearable="true"
            label="手机号"
            placeholder="请输入手机号"
            name="mobile"
            :rules="[
              {required: true, message: '请输入员工手机号' },
              {validator:validatorPhone,message: '请输入正确的手机号'}
            ]"
          />
        </van-cell-group>
        <!-- <div class="tips">
        Tips：常用角色有生产人员、仓库管理员、技术人员等
      </div> -->
        <van-button block type="info" native-type="submit" class="sub-btn">
          确定
        </van-button>
        <!-- <div v-show="form.id" class="page-bottom-btn" style="color:#ff8968;" @click="deleteUserFn">
          <van-icon name="delete" color="#ff8968" size="17px" />&nbsp;删除员工
        </div> -->
      </div>
    </van-form>
  </van-popup>
</template>
<script>
import api from '@/api'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'create'
    },
    initFormData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    initFormData: {
      handler(newV) {
        this.form = { ...newV }
      },
      immediate: true
    },
    visible: {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.harvestForm.resetValidation()
        })
      }
    }
  },

  methods: {
    aaa() {
      console.log(11)
    },
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val)
    },
    hidePopup() {
      this.$emit('update:visible', false)
      this.$emit('close', false)
    },
    submitFormSuccess(flag = true) {
      this.$emit('submitFormSuccess', flag)
    },
    submitForm() {
      if (this.form.id) {
        api.updateStaff(this.form).then(res => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      } else {
        api.createStaff(this.form).then(res => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      }
    },
    deleteUserFn() {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        api.deleteStaff({ ids: [parseInt(this.form.id)] }).then(res => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-nav-bar__text{
  color: red;
}
.main{
   height: calc(100vh - 46px);
  padding: 16px 0;
  background-color: #f3f7f8;
  position: relative;
  .page-bottom-btn{
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    height: 60px;
    padding-top: 20px;
    display: flex;
    align-content: center;
    justify-content: center;
  }
}
.item-warp{
  padding: 10px 0;
}
.tips{
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
  color: #999;
}
.sub-btn{
  height: 80px;
  position: fixed;
  bottom: 0;
}
</style>
